module.exports = __webpack_public_path__ + "img/local-23.8225d1fe.jpg";